import { render } from "./IdenticalFormulationModal.vue?vue&type=template&id=d3526fb8&scoped=true"
import script from "./IdenticalFormulationModal.vue?vue&type=script&setup=true&lang=js"
export * from "./IdenticalFormulationModal.vue?vue&type=script&setup=true&lang=js"

import "./IdenticalFormulationModal.vue?vue&type=style&index=0&id=d3526fb8&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3003388635/src/git-codecommit.ap-northeast-1.amazonaws.com/v1/repos/portal-dev-frontend/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3526fb8"],['__file',"src/pages/components/parts/IdenticalFormulationModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d3526fb8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d3526fb8', __exports__)) {
    console.log('reload')
    api.reload('d3526fb8', __exports__)
  }
  
  module.hot.accept("./IdenticalFormulationModal.vue?vue&type=template&id=d3526fb8&scoped=true", () => {
    console.log('re-render')
    api.rerender('d3526fb8', render)
  })

}


export default __exports__